import L from "leaflet";

const trainSvg = `
  <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="20" cy="20" r="18" fill="#1d4ed8" stroke="#fff" stroke-width="2.5"/>
    <path fill="#fff" d="M12 14.5h13.5a3 3 0 0 1 3 3V24h-2.2a3.2 3.2 0 0 1-6.1 0h-5.4a3.2 3.2 0 0 1-6.1 0H8v-6.5a3 3 0 0 1 3-3h1zm2.2 3.2v3.4h6.2v-3.4h-6.2zm8.4 0v3.4h4.1a1 1 0 0 0 1-1v-2.4h-5.1zM13.6 26.2a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2zm10.7 0a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2z"/>
  </svg>
`;

export const trainIcon = L.divIcon({
  className: "train-marker",
  html: `<div class="train-marker-inner">${trainSvg}</div>`,
  iconSize: [40, 40],
  iconAnchor: [20, 20],
  popupAnchor: [0, -18],
});

function flagHtml(kind: "start" | "end", label: string) {
  return `<div class="map-flag map-flag-${kind}"><span class="map-flag-pole"></span><span class="map-flag-cloth">${label}</span></div>`;
}

export const startFlagIcon = L.divIcon({
  className: "flag-marker",
  html: flagHtml("start", "START"),
  iconSize: [64, 42],
  iconAnchor: [4, 42],
  popupAnchor: [16, -36],
});

export const endFlagIcon = L.divIcon({
  className: "flag-marker",
  html: flagHtml("end", "END"),
  iconSize: [56, 42],
  iconAnchor: [4, 42],
  popupAnchor: [16, -36],
});

const checkSvg = `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2.2 6.2 4.8 8.8 9.8 3.2"/></svg>`;

export const stationOpenIcon = L.divIcon({
  className: "station-dot",
  html: `<span class="station-radio"></span>`,
  iconSize: [18, 18],
  iconAnchor: [9, 9],
  popupAnchor: [0, -10],
});

export const stationCrossedIcon = L.divIcon({
  className: "station-dot",
  html: `<span class="station-radio station-radio-checked">${checkSvg}</span>`,
  iconSize: [18, 18],
  iconAnchor: [9, 9],
  popupAnchor: [0, -10],
});
